// Downsize a picked photo before it leaves the phone: cameras hand us 3–12 MB
// and the server keeps only 512 px anyway. Redrawing on a canvas also drops the
// EXIF block (GPS included); <img> decoding already applies EXIF orientation.
export const UPLOAD_MAX_SIDE = 1024;

/** Scale (width, height) to fit inside maxSide x maxSide. Never scales up. */
export const fitWithin = (width, height, maxSide = UPLOAD_MAX_SIDE) => {
  const scale = Math.min(1, maxSide / Math.max(width, height));
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
};

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("No se pudo leer la imagen."));
    };
    img.src = url;
  });

export const resizeImageFile = async (file, { maxSide = UPLOAD_MAX_SIDE, quality = 0.85 } = {}) => {
  const img = await loadImage(file);
  const { width, height } = fitWithin(img.naturalWidth, img.naturalHeight, maxSide);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d").drawImage(img, 0, 0, width, height);
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("No se pudo procesar la imagen."))),
      "image/jpeg",
      quality,
    );
  });
};

/** Multipart body for POST /athletes/:id/avatar and /scouts/:id/avatar. */
export const buildAvatarForm = async (file) => {
  const form = new FormData();
  form.append("file", await resizeImageFile(file), "avatar.jpg");
  return form;
};
